
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn color="blue" :class="{ 'float-right': floatRight, 'mx-2': floatRight }" v-bind="props"><v-icon
                class="mr-2">mdi-bank-transfer</v-icon> Transferir</v-btn>
    </template>
    <v-card>
      <v-toolbar color="blue" title="Nova transferência">
        <v-btn color="black" @click="dialog = false">
          <v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormCashierTransfer @created="dialog = false" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormCashier from "./FormCashier.vue";
import FormCashierTransfer from "./FormCashierTransfer.vue";
export default {
  components: { FormCashier, FormCashierTransfer },
  props: {
    user: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
  },
  computed: {},
  watch: {
  },
};
</script>
